import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ASSETS } from "@/lib/assets";

const STATUS = { approved: "bg-neon text-black", pending: "bg-gold text-black", rejected: "bg-danger text-white" };

export default function MyContent({ mode }) {
  const { data = [], isLoading } = useQuery({
    queryKey: ["my-stories"],
    queryFn: async () => (await api.get("/me/stories")).data,
  });
  const items = mode === "memes" ? data.filter((s) => s.image_url) : data.filter((s) => !s.image_url);
  const title = mode === "memes" ? "MY MEMES" : "MY STORIES";
  const cta = mode === "memes" ? { to: "/memes", label: "Make A Meme" } : { to: "/wall", label: "Confess A Story" };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
      <h1 className="headline text-cream text-4xl mt-2">{title.split(" ")[0]} <span className="text-neon">{title.split(" ")[1]}</span></h1>
      {isLoading ? (
        <p className="font-mono text-dim mt-8">Loading...</p>
      ) : items.length === 0 ? (
        <div className="flex flex-col items-center py-16 text-center">
          <img src={ASSETS.shrugging} alt="empty" className="w-40" />
          <p className="font-display text-cream mt-4 uppercase">Nothing here yet.</p>
          <Link to={cta.to} className="btn-neon mt-6">{cta.label}</Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {items.map((s) => (
            <div key={s.id} className="comic-card p-4" data-testid={`mine-${s.id}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-[10px] text-dim">{new Date(s.created_at).toLocaleDateString()}</span>
                <span className={`tag !text-[9px] !px-2 !py-0.5 ${STATUS[s.status] || ""}`}>{s.status}</span>
              </div>
              {s.image_url && <img src={`${process.env.REACT_APP_BACKEND_URL}${s.image_url}`} alt="meme" className="mt-3 w-full max-h-64 object-contain border-3 border-black bg-white" />}
              {s.story && <p className="font-mono text-sm text-cream/90 mt-3">"{s.story}"</p>}
              <p className="font-mono text-[10px] text-neon mt-3">▲ {s.upvotes} upvotes</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
